const translations = {
    noItemsFound: 'No items found'
};

export default translations;
